export default __webpack_public_path__ + "static/media/teacherLagbe.26500eed.png";